'use client';
import Link from "next/link";
import { useState, useEffect } from 'react';

export default function Layout({
  children,
}: {
  children: React.ReactNode;
}) {
  const [theme, setTheme] = useState('light');

  useEffect(() => {
    // Periksa apakah sessionStorage memiliki nilai
    let sessionTheme = sessionStorage.getItem('theme');
    if (!sessionTheme) {
      // Jika sessionStorage kosong, gunakan nilai dari localStorage
      const storedTheme = localStorage.getItem('theme') || 'light';
      sessionStorage.setItem('theme', storedTheme);
      sessionTheme = storedTheme;
    }

    // Terapkan tema berdasarkan sessionStorage
    if (sessionTheme === 'dark') {
      document.documentElement.classList.add('dark');
      setTheme('dark');
    } else {
      document.documentElement.classList.remove('dark');
      setTheme('light');
    }
  }, []);
  return (
    <>
      <main className="max-w-[520px] px-4 lg:px-0 mx-auto w-full text-white pt-8">
        {children}
      </main>
      <div className="max-w-[520px] mx-auto">
        <span className='flex flex-wrap justify-center px-5 lg:px-0 py-4 lg:space-x-6 space-x-4 text-xs font-semibold xl:text-sm text-theme-gray lg:gap-y-3 gap-y-2'>
          <Link href="/payment-confirm">Konfirmasi Pembayaran</Link>
          <Link href="/page/about">Tentang MastermindEO</Link>
          <Link href="/page/privacy-policy">Kebijakan Privasi</Link>
          <Link href="/page/terms-and-condition">Syarat & Ketentuan</Link>
          <Link href="/page/faq">FAQ</Link>
        </span>
      </div>
    </>
  );
}
